import { render, staticRenderFns } from "./CustomerProtection.vue?vue&type=template&id=193e2c9a"
import script from "./CustomerProtection.vue?vue&type=script&lang=js"
export * from "./CustomerProtection.vue?vue&type=script&lang=js"
import style0 from "./CustomerProtection.vue?vue&type=style&index=0&id=193e2c9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports